import React from 'react';

function Vanuatu(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123959)">
        <mask
          id="mask0_800_123959"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123959)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V8H36V0H0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16V24H36V16H0Z"
            fill="#5EAA22"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 -2L18.7533 12L0 26V-2Z"
            fill="#272727"
          />
          <mask
            id="path-7-outside-1_800_123959"
            maskUnits="userSpaceOnUse"
            x="-2"
            y="-7.35498"
            width="40"
            height="38"
            fill="black"
          >
            <rect fill="white" x="-2" y="-7.35498" width="40" height="38" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 -3.35498L19.5843 9.99994H36V13.9999H19.3156L0 26.8115V22.3402L15.75 12L0 1.53447V-3.35498Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 -3.35498L19.5843 9.99994H36V13.9999H19.3156L0 26.8115V22.3402L15.75 12L0 1.53447V-3.35498Z"
            fill="#FFD018"
          />
          <path
            d="M19.5843 9.99994L18.4575 11.6523L18.9673 11.9999H19.5843V9.99994ZM0 -3.35498L1.12679 -5.00736L-2 -7.13958V-3.35498H0ZM36 9.99994H38V7.99994H36V9.99994ZM36 13.9999V15.9999H38V13.9999H36ZM19.3156 13.9999V11.9999H18.7126L18.2101 12.3332L19.3156 13.9999ZM0 26.8115H-2V30.538L1.10548 28.4782L0 26.8115ZM0 22.3402L-1.09763 20.6683L-2 21.2607V22.3402H0ZM15.75 12L16.8476 13.6719L19.3789 12.01L16.8569 10.3342L15.75 12ZM0 1.53447H-2V2.60679L-1.10687 3.20025L0 1.53447ZM20.7111 8.34756L1.12679 -5.00736L-1.12679 -1.7026L18.4575 11.6523L20.7111 8.34756ZM36 7.99994H19.5843V11.9999H36V7.99994ZM38 13.9999V9.99994H34V13.9999H38ZM19.3156 15.9999H36V11.9999H19.3156V15.9999ZM1.10548 28.4782L20.4211 15.6666L18.2101 12.3332L-1.10548 25.1448L1.10548 28.4782ZM-2 22.3402V26.8115H2V22.3402H-2ZM14.6524 10.3281L-1.09763 20.6683L1.09763 24.012L16.8476 13.6719L14.6524 10.3281ZM-1.10687 3.20025L14.6431 13.6658L16.8569 10.3342L1.10687 -0.131311L-1.10687 3.20025ZM-2 -3.35498V1.53447H2V-3.35498H-2Z"
            fill="#272727"
            mask="url(#path-7-outside-1_800_123959)"
          />
          <path
            d="M5.48292 16.768L5.48516 15.1877C7.06953 14.877 8.1191 14.4729 8.62998 13.9869C9.888 12.6087 9.05172 9.37983 6.46718 9.40094C5.18672 9.40094 3.86261 9.94333 3.86261 11.2199C3.86261 12.8053 4.22965 13.483 5.48516 13.483C6.73285 13.483 7.19028 13.5423 8.01215 12.5466L8.90403 12.7916C8.02333 13.8586 6.83617 14.7014 5.48292 14.7014C3.25368 14.7014 2.04053 13.2074 2.04053 11.4795C2.04053 9.34636 3.98867 7.85242 6.3376 7.85242C8.09025 7.85242 10.8624 9.76062 10.8624 11.4795C10.8624 13.1983 10.8624 13.9869 9.34235 15.1877C8.7301 15.6714 7.21309 16.5351 5.48292 16.768Z"
            fill="#FFD018"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.61546 9.87983C5.52964 9.85969 5.4417 9.9052 5.41904 9.98148L5.3576 10.1883C5.35453 10.1848 5.35146 10.1812 5.34838 10.1777C5.29413 10.1152 5.1932 10.1037 5.12295 10.1519C5.0527 10.2002 5.03973 10.2899 5.09399 10.3523C5.13122 10.3952 5.16795 10.4375 5.20419 10.4794L5.01897 10.6314C4.95376 10.6849 4.94971 10.7753 5.00993 10.8333C5.07014 10.8912 5.17182 10.8948 5.23703 10.8413L5.4007 10.707C5.49841 10.8205 5.59204 10.9298 5.68151 11.0349L5.37343 11.1819C5.29523 11.2192 5.26587 11.3058 5.30785 11.3753C5.34983 11.4448 5.44726 11.4709 5.52547 11.4336L5.87732 11.2657C5.96175 11.3657 6.0418 11.4611 6.11738 11.5517L5.69485 11.7534C5.61665 11.7907 5.58729 11.8773 5.62927 11.9468C5.67125 12.0163 5.76868 12.0424 5.84689 12.0051L6.30988 11.7841C6.43301 11.9339 6.54095 12.0674 6.63311 12.1838L6.33769 12.3248C6.25948 12.3621 6.23012 12.4487 6.27211 12.5182C6.31409 12.5877 6.41152 12.6138 6.48972 12.5765L6.81669 12.4205C6.95268 12.6006 7.02308 12.7087 7.02308 12.7371C7.02308 12.816 7.09504 12.8799 7.1838 12.8799C7.27256 12.8799 7.34451 12.816 7.34451 12.7371C7.34451 12.6648 7.25989 12.5127 7.08304 12.2689C7.0856 12.265 7.08794 12.2609 7.09007 12.2568L7.32789 11.7913C7.3646 11.7195 7.32884 11.6348 7.24802 11.6022C7.16721 11.5696 7.07194 11.6013 7.03523 11.6732L6.87277 11.9911C6.77128 11.8613 6.6528 11.7143 6.51677 11.5493L6.68505 11.2199C6.72176 11.1481 6.686 11.0634 6.60518 11.0308C6.52437 10.9981 6.4291 11.0299 6.3924 11.1018L6.29806 11.2864C6.24607 11.2244 6.19203 11.1603 6.13594 11.0941L6.36364 10.6484C6.40034 10.5766 6.36458 10.4919 6.28377 10.4593C6.20295 10.4267 6.10768 10.4585 6.07098 10.5303L5.91534 10.8349C5.81732 10.7203 5.71395 10.6 5.60516 10.4741L5.72982 10.0544C5.75248 9.97814 5.70128 9.89997 5.61546 9.87983Z"
            fill="#FFD018"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.69606 9.87983C6.78188 9.85969 6.86982 9.9052 6.89248 9.98148L6.95392 10.1883C6.95699 10.1848 6.96006 10.1812 6.96314 10.1777C7.01739 10.1152 7.11832 10.1037 7.18857 10.1519C7.25882 10.2002 7.27179 10.2899 7.21754 10.3523C7.18031 10.3952 7.14357 10.4375 7.10734 10.4794L7.29255 10.6314C7.35776 10.6849 7.36181 10.7753 7.3016 10.8333C7.24138 10.8912 7.1397 10.8948 7.07449 10.8413L6.91083 10.707C6.81312 10.8205 6.71948 10.9298 6.63002 11.0349L6.93809 11.1819C7.0163 11.2192 7.04566 11.3058 7.00367 11.3753C6.96169 11.4448 6.86426 11.4709 6.78606 11.4336L6.4342 11.2657C6.34977 11.3657 6.26972 11.4611 6.19414 11.5517L6.61667 11.7534C6.69488 11.7907 6.72424 11.8773 6.68225 11.9468C6.64027 12.0163 6.54284 12.0424 6.46464 12.0051L6.00165 11.7841C5.87852 11.9339 5.77058 12.0674 5.67841 12.1838L5.97384 12.3248C6.05204 12.3621 6.0814 12.4487 6.03942 12.5182C5.99743 12.5877 5.9 12.6138 5.8218 12.5765L5.49483 12.4205C5.35885 12.6006 5.28844 12.7087 5.28844 12.7371C5.28844 12.816 5.21649 12.8799 5.12773 12.8799C5.03897 12.8799 4.96701 12.816 4.96701 12.7371C4.96701 12.6648 5.05164 12.5127 5.22848 12.2689C5.22593 12.265 5.22358 12.2609 5.22145 12.2568L4.98363 11.7913C4.94693 11.7195 4.98269 11.6348 5.0635 11.6022C5.14432 11.5696 5.23959 11.6013 5.27629 11.6732L5.43875 11.9911C5.54025 11.8613 5.65872 11.7143 5.79475 11.5493L5.62647 11.2199C5.58976 11.1481 5.62552 11.0634 5.70634 11.0308C5.78715 10.9981 5.88242 11.0299 5.91913 11.1018L6.01346 11.2864C6.06546 11.2244 6.11949 11.1603 6.17558 11.0941L5.94789 10.6484C5.91118 10.5766 5.94694 10.4919 6.02776 10.4593C6.10857 10.4267 6.20384 10.4585 6.24055 10.5303L6.39618 10.8349C6.49421 10.7203 6.59757 10.6 6.70637 10.4741L6.58171 10.0544C6.55905 9.97814 6.61025 9.89997 6.69606 9.87983Z"
            fill="#FFD018"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123959">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Vanuatu;
